import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Overview from "./components/Overview";
import Categories from "./components/Categories";
import Catalog from "./components/Catalog";
import Collections from "./components/Collections";
import Series from "./components/Series";
import Recommend from "./components/Recommend";
import Faq from "./components/Faq";
import Notice from "./components/Notice";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <Categories />
        <Catalog />
        <Collections />
        <Series />
        <Recommend />
        <Faq />
        <Notice />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}